module.exports = __webpack_public_path__ + "a292eb2c80c9c8964f72cd81d02f6bb5.svg";